/** @file useSession: asks the server who is signed in once (`GET /auth/me`) and records it in `session`. */
import { useEffect } from 'react';
import type { EditorStore } from '../state/editorTypes';
import type { EditorApi } from '../store/editorApi';

/** While `session.status` is `unknown`: `me()` → signed-in with its owner, any failure → anonymous (login screen). */
export function useSession(store: EditorStore, api: EditorApi | null): void {
  useEffect(() => {
    if (api === null || store.getState().session.status !== 'unknown') return;
    let live = true;
    api.me().then(
      (me) => { if (live) store.setState((s) => ({ session: { ...s.session, owner: me.owner, status: 'signed-in' } })); },
      () => { if (live) store.setState((s) => ({ session: { ...s.session, owner: null, status: 'anonymous' } })); },
    );
    return () => { live = false; };
  }, [store, api]);
}
